module.exports = __webpack_public_path__ + "img/18_62.1e0e2f3e.png";